import request from '@/utils/request';

/**
 * 控制台相关接口
 * @method getDeviceInfo 获取设备信息：设备总数、国标设备/流设备数、设备在线/离线数
 * @method getDeviceTrend 获取设备状态趋势
 * @method getDeviceDistribution 获取设备离线时长
 * @method getSystemInfo 获取系统信息，cpu、内存、磁盘、网络情况
 * @method getMediaLoad 获取负载信息
 * @method getResource 获取资源，设备数、通道数、推流数、拉流代理等
 * @method getSystemConfigInfo 获取系统配置信息
 * 
 * @method getTiandituKey 获取天地图的密钥key
 */

export function getDeviceInfo () {
  return request({
    url: '/api/board/devices/info',
    method: 'GET',
  })
}

export function getDeviceTrend () {
  return request({
    url: '/api/board/devices/trend',
    method: 'GET',
  })
}

export function getDeviceDistribution () {
  return request({
    url: '/api/board/devices/distribution',
    method: 'GET',
  })
}


export function getSystemInfo () {
  return request({
    url: '/api/server/system/info',
    method: 'GET',
  })
}

export function getMediaLoad () {
  return request({
    url: '/api/server/media_server/load',
    method: 'GET',
  })
}

export function getResource () {
  return request({
    url: '/api/server/resource/info',
    method: 'GET',
  })
}

export function getSystemConfigInfo () {
  return request({
    url: '/api/server/system/configInfo',
    method: 'GET',
  })
}

export function getTiandituKey () {
  return request({
    url: '/api/server/map/key',
    method: 'GET',
  })
}


// WEBPACK FOOTER //
// ./src/api/console.js